// Local FiscalPOS print agent (print-agent/fiscalpos_print_agent.py) on this device.
// It delivers bytes to network printers (IP:9100) and OS print queues (USB/macOS/Windows),
// which a browser tab cannot reach itself.

export const AGENT_URL = 'http://127.0.0.1:17777';

async function agentFetch(path, { method = 'GET', body, timeoutMs = 5000 } = {}) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetch(`${AGENT_URL}${path}`, {
      method,
      headers: body ? { 'Content-Type': 'application/json' } : undefined,
      body: body ? JSON.stringify(body) : undefined,
      signal: controller.signal,
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.ok === false) {
      throw new Error(data.error || `Druck-Agent antwortet mit ${response.status}`);
    }
    return data;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw new Error('Druck-Agent antwortet nicht (Zeitüberschreitung)');
    }
    if (error instanceof TypeError) {
      // fetch() network failure: agent not running or blocked by the browser.
      throw new Error('Druck-Agent auf diesem Gerät nicht erreichbar. Bitte starten (siehe print-agent/README.md).');
    }
    throw error;
  } finally {
    clearTimeout(timer);
  }
}

export async function getAgentHealth() {
  try {
    return await agentFetch('/health', { timeoutMs: 1500 });
  } catch {
    return null;
  }
}

// Finds printers on this device by itself: OS queues (USB / network / Bluetooth),
// plugged-in USB printers without queue, network printers with IP, paired Bluetooth ports.
export const discoverWithAgent = () => agentFetch('/discover', { timeoutMs: 30000 });

// Creates the OS print queue for a plugged-in printer (e.g. USB) and returns its queue name.
export const setupQueueWithAgent = ({ uri, name }) =>
  agentFetch('/setup-queue', { method: 'POST', timeoutMs: 30000, body: { uri, name } }).then((data) => data.queue);

export const printWithAgent = ({ transport, target, contentType, dataBase64, title }) =>
  agentFetch('/print', {
    method: 'POST',
    timeoutMs: 20000,
    body: { transport, target, content_type: contentType, data_base64: dataBase64, title },
  });
